(function () {
  function up(el, sel) {
    if (!el || typeof el.closest !== 'function') return null;
    return el.closest(sel);
  }

  var seen = {};
  function preload(url) {
    if (!url || seen[url]) return;
    seen[url] = true;
    var i = new Image();
    i.src = url;
  }

  function pickColor(sw) {
    var card = up(sw, '[data-mcd]');
    if (!card) return;

    card.querySelectorAll('[data-mcd-swatch]').forEach(function (o) {
      var on = o === sw;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var id = card.querySelector('[data-mcd-id]');
    if (id) id.value = sw.getAttribute('data-variant') || id.value;

    var nameBox = card.querySelector('[data-mcd-colorname]');
    if (nameBox) nameBox.textContent = sw.getAttribute('data-name') || '';

    var alt = card.querySelector('[data-mcd-alt]');
    if (alt) {
      alt.style.setProperty('opacity', '0', 'important');
      alt.style.setProperty('visibility', 'hidden', 'important');
    }

    var url = sw.getAttribute('data-image');
    var img = card.querySelector('[data-mcd-img]');
    if (img && url) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.style.setProperty('opacity', '0');
      var probe = new Image();
      probe.onload = probe.onerror = function () {
        img.setAttribute('src', url);
        img.style.setProperty('opacity', '1');
      };
      probe.src = url;
    }

    var price = card.querySelector('[data-mcd-price]');
    if (price) {
      var html = '<span class="mcd__price-now">' + (sw.getAttribute('data-price') || '') + '</span>';
      var cmp = sw.getAttribute('data-compare');
      if (cmp) html += '<s class="mcd__price-was">' + cmp + '</s>';
      price.innerHTML = html;
    }

    var href = sw.getAttribute('data-url');
    if (href) {
      card.querySelectorAll('[data-mcd-link]').forEach(function (a) {
        a.setAttribute('href', href);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var sw = up(event.target, '[data-mcd-swatch]');
    if (sw) {
      event.preventDefault();
      event.stopPropagation();
      pickColor(sw);
      return;
    }

    var trig = up(event.target, '[data-mgr-trig]');
    if (trig) {
      var pill = up(trig, '[data-mgr-pill]');
      var open = pill && pill.dataset.open === 'true';
      document.querySelectorAll('[data-mgr-pill]').forEach(function (p) {
        p.dataset.open = 'false';
        var pane = p.querySelector('[data-mgr-panel]');
        if (pane) pane.hidden = true;
      });
      if (pill && !open) {
        pill.dataset.open = 'true';
        var panel = pill.querySelector('[data-mgr-panel]');
        if (panel) panel.hidden = false;
      }
      return;
    }

    if (!up(event.target, '[data-mgr-panel]')) {
      document.querySelectorAll('[data-mgr-pill]').forEach(function (p) {
        p.dataset.open = 'false';
        var pane = p.querySelector('[data-mgr-panel]');
        if (pane) pane.hidden = true;
      });
    }
  }, true);

  document.addEventListener('mouseover', function (event) {
    var card = up(event.target, '[data-mcd]');
    if (!card || card.dataset.mcdPre === '1') return;
    card.dataset.mcdPre = '1';
    card.querySelectorAll('[data-mcd-swatch]').forEach(function (s) {
      preload(s.getAttribute('data-image'));
    });
  });

  document.addEventListener('submit', function (event) {
    var form = up(event.target, '[data-mcd-form]');
    if (!form) return;
    event.preventDefault();
    var cta = form.querySelector('[data-mcd-cta]');
    var label = form.querySelector('[data-mcd-cta-label]');
    var original = label ? label.textContent : '';
    var idField = form.querySelector('[data-mcd-id]');
    if (!idField) return;
    if (cta) cta.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: idField.value, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (label) label.textContent = 'Agregado';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.setTimeout(function () {
          if (label) label.textContent = original;
          if (cta) cta.classList.remove('is-busy');
        }, 1600);
      })
      .catch(function () {
        if (label) label.textContent = original;
        if (cta) cta.classList.remove('is-busy');
      });
  });

  document.addEventListener('change', function (event) {
    var auto = up(event.target, '[data-mgr-auto]');
    if (!auto) return;
    var form = auto.closest('form');
    if (form) form.submit();
  });

  function reveal(scope) {
    var cards = (scope || document).querySelectorAll('.mgr__reveal .mcd');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
